import { Box } from '@mui/material';
import { LoginButton } from 'src/components/LoginButton';
import HeaderUserbox from '../Userbox';
import { useAuth0 } from '@auth0/auth0-react';

interface HeaderButtonsProps {}

export const HeaderButtons: React.FC<HeaderButtonsProps> = () => {
  const { isAuthenticated } = useAuth0();

  return (
    <Box sx={{ mr: 1 }}>
      {!isAuthenticated ? (
        <LoginButton label="Login" />
      ) : (
        <HeaderUserbox />
      )}
    </Box>
  );
};
